<template>
  <span
    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border"
    :class="[backgroundColor, textColor, borderColor || backgroundColor]"
  >
    <slot>{{ value }}</slot>
  </span>
</template>

<script setup lang="ts">
interface Props {
  value?: string
  backgroundColor: string
  textColor: string
  borderColor?: string
  icon?: string
}

defineProps<Props>()
</script>
